export default class ChangeSelectionAction {
    constructor(selection, selectionBefore) {
        this.selection = selection;
        this.selectionBefore = selectionBefore;
        this.type = 'changeSelection';
        this.time = Date.now();
    }
    apply(state, dom, logger) {
        state.selection = this.selection;
        dom.setSelection(this.selection);
        return {
            idsToEvaluate: []
        };
    }
    undo(state, dom, logger) {
        state.selection = this.selectionBefore;
        dom.setSelection(this.selectionBefore);
        return {
            idsToEvaluate: []
        };
    }
    getDataToMergeWithNext(nextType) {
        return {};
    }
    mergeWithPrevious(previousType, previousData) {
        return false;
    }
}
